import { Breadcrumb, BreadcrumbLink } from "@/components/breadcrumb.tsx";
import { useGlobals } from "@/components/providers/globals-provider.tsx";
import { useTranslations } from "@/features/translations/components/translations";
import { useAppSelector } from "@/redux/store.ts";
import { WebComponentMode } from "@/types";

export default function Breadcrumbs() {
    const { navigation, mode } = useGlobals();
    const t = useTranslations();

    const family = useAppSelector((state) => state.subFamily.family);

    if (!navigation || mode !== WebComponentMode.Website) return null;

    const { homepageUrl, familyUrl, productsUrl } = navigation;

    return (
        <Breadcrumb>
            <BreadcrumbLink href={homepageUrl}>{t("breadcrumb_homepage")}</BreadcrumbLink>
            <BreadcrumbLink href={productsUrl}>{t("breadcrumb_products")}</BreadcrumbLink>
            <BreadcrumbLink href={familyUrl}>{family}</BreadcrumbLink>
        </Breadcrumb>
    );
}
